<template>
  <div ref="container" class="tw-overflow-x-hidden" @mouseenter="onEnter" @mouseleave="onLeave">
    <div class="mask" :style="maskStyle">
      <div ref="textRef" :class="textClasses" :style="textStyle">
        {{ text }}
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, nextTick } from "vue";
import gsap from "gsap";

const props = defineProps({
  text: { type: String, required: true },
  maxLength: { type: Number, default: 100 },
  textClasses: { type: String, default: "" },
});

const container = ref(null);
const textRef = ref(null);
let animation = null;
const isHovered = ref(false);

const onEnter = async () => {
  isHovered.value = true;
  await nextTick();

  const maskWidth = container.value.querySelector(".mask").offsetWidth;
  const textWidth = textRef.value.scrollWidth;

  if (textWidth <= maskWidth) return;

  animation = gsap.to(textRef.value, {
    x: textWidth - maskWidth,
    duration: 3,
    ease: "power1.inOut",
    repeat: -1,
    yoyo: true,
  });
};

const onLeave = () => {
  isHovered.value = false;
  if (animation) animation.kill();
  gsap.to(textRef.value, { x: 0, duration: 0.5, ease: "power1.out" });
};

const maskStyle = computed(() => ({
  maxWidth: `${props.maxLength}ch`,
  overflow: "hidden",
  whiteSpace: "nowrap",
  display: "flex",
}));

const textStyle = computed(() => ({
  display: "inline-block",
  // cursor: "pointer",
  whiteSpace: "nowrap",
  maxWidth: "100%",
  overflow: isHovered.value ? "visible" : "hidden",
  textOverflow: isHovered.value ? "clip" : "ellipsis",
}));
</script>
